import {
    selectAppStatus,
    selectErrorMessage, selectIsAbortedPromise,
    selectSuccessMessage, setAppStatus,
} from '../store/appStatusReducer'
import './App.less'
import {useAppDispatch, useAppSelector} from './hooks'
import routes from './routes'
import {Alert} from '@mui/material'
import {Snackbar} from "@material-ui/core";
import {LicenseInfo} from '@mui/x-license-pro';
import { Routes, Route, Navigate} from 'react-router-dom';
import {selectIsLoggedIn} from "../store/userReducer";
import 'dayjs/locale/de'
import dayjs from 'dayjs'
dayjs.locale('de')

function App() {
    const appStatus = useAppSelector(selectAppStatus)
    const error = useAppSelector(selectErrorMessage)
    const successMessage = useAppSelector(selectSuccessMessage)
    const isAbortedPromise = useAppSelector(selectIsAbortedPromise)
    const dispatch = useAppDispatch()
    LicenseInfo.setLicenseKey('226e36154a9516d7588b449af3ebdcc1Tz0xMjQxMzksRT0xNzk5NzExOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=');
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            dispatch(setAppStatus(0))
            return dispatch(setAppStatus(0));
        }
        dispatch(setAppStatus(0))
        return dispatch(setAppStatus(0));
    };
    return (
        <div className='app'>
            <Snackbar open={appStatus === 3 && !isAbortedPromise} autoHideDuration={7}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert severity="error" sx={{
                    width: '100%', vertical: 'top',
                    horizontal: 'center',
                }}
                       onClose={handleClose}
                >
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={appStatus === 2} autoHideDuration={7}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert severity="success" sx={{width: '100%',}} onClose={handleClose}>
                    {successMessage}
                </Alert>
            </Snackbar>
            <Routes>
                {routes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            route.auth ? (
                                <PrivateRoute>
                                    <route.component {...route.props} />
                                </PrivateRoute>
                            ) : (
                                <route.component {...route.props} />
                            )
                        }
                    />
                ))}
            </Routes>
        </div>
    )
}

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const isLoggedIn = useAppSelector(selectIsLoggedIn);
    return isLoggedIn ? children : <Navigate to="/sign-in" replace />;
};



export default App
